var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "searchLoading__overlay" }, [
    _c("div", { staticClass: "searchLoading__wrapper fadeIn z-index-1" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "h5 subline margin-bottom-0" }, [
        _vm._v(
          "\n            " + _vm._s(_vm.trans("PLEASE_WAIT")) + "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cssPreloader" }, [
      _c("div", { staticClass: "cssPreloader__inner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }